import { cn } from "@/utils/classNames"
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import { FiClock, FiCalendar } from "react-icons/fi"

type SchedulePanelProps = {
  schedule: {
    id: string
    name: string
    time: string
    days: Array<{
      name: string
      active: boolean
    }>
    enabled: boolean
  }
}

export function SchedulePanel({ schedule }: SchedulePanelProps) {
  return (
    <div className="border border-gray-200 dark:border-gray-700 rounded-md overflow-hidden shadow-sm hover:shadow-md transition-shadow duration-200">
      <Accordion type="single" collapsible defaultValue="">
        <AccordionItem value={schedule.id} className="border-0">
          <div className="flex items-center justify-between px-4 py-3 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 transition-colors duration-200">
            <div className="flex items-center gap-3">
              <div 
                className={cn(
                  "w-3 h-3 rounded-full transition-colors duration-200",
                  schedule.enabled ? "bg-green-500" : "bg-gray-300 dark:bg-gray-500"
                )} 
              />
              <div>
                <h5 className="text-sm font-medium text-gray-800 dark:text-gray-200">{schedule.name}</h5>
                <div className="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
                  <div className="flex items-center gap-1">
                    <FiClock className="h-3.5 w-3.5 text-gray-600 dark:text-gray-400" />
                    <span>{schedule.time}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <FiCalendar className="h-3.5 w-3.5 text-gray-600 dark:text-gray-400" />
                    <span>{schedule.days.filter(d => d.active).length} days</span>
                  </div>
                </div>
              </div>
            </div>
            <AccordionTrigger className="hover:no-underline p-0 ml-auto group text-gray-500 dark:text-gray-400"></AccordionTrigger>
          </div>

          <AccordionContent className="px-4 pb-4 pt-2 bg-gray-50 dark:bg-gray-800">
            <div className="space-y-4">
              <div>
                <p className="text-xs font-medium text-gray-600 dark:text-gray-400 mb-3">Active Days</p>
                <div className="flex gap-2">
                  {schedule.days.map((day) => (
                    <div
                      key={day.name}
                      className={cn(
                        "w-8 h-8 rounded-full flex items-center justify-center text-xs font-medium transition-all duration-200",
                        day.active 
                          ? "bg-cyan-500 text-white shadow-sm" 
                          : "bg-gray-100 text-gray-500 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600"
                      )}
                    >
                      {day.name.substring(0, 1)}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  )
}
